
  
  export default function somenteNumeros(texto) {
    return texto.replace(/[^0-9]/g,'');
  }
  

  